'use strict';

module.exports = function(cb) {
    if (cb) {
        if (window.SCHD_COMS) {
            if (window.SCHD_COMS.SCXman) {
                cb(window.SCHD_COMS.SCXman);
            } else if (window.SCHD_COMS.use) {
                window.SCHD_COMS.use(['xman'], function() {
                    if (window.SCHD_COMS.SCXman) {
                        cb(window.SCHD_COMS.SCXman);
                    }
                });
            }
        }
    }
};
